<template>
  <v-container>
    <v-form ref="form" v-model="validado">
      <v-row dense>
        <!-- Botón de regreso -->
        <v-row dense class="align-center justify-space-between">
          <v-col cols="auto">
            <v-btn icon @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <!-- <v-btn class="cancel" @click="Cancelar"> Cancelar </v-btn> -->
            <!--  <v-col cols="3">
          <form-meta
            :data="registro"
            :remove-commit="'removerAcuicultura'"
            :record-id="registro.id"
            @removed="$router.go(-1)"
          />
          </v-col> -->
            <save-btn
              class="btn-oval"
              :record-status="registro.estatus"
              :loading="loading"
              @click="antesDeGuardar"
            />
          </v-col>
        </v-row>
        <v-col cols="12">
          <div class="text-h4 font-weight-bold">
            🦐 🐟 Producción y Venta Acuícola
          </div>
        </v-col>
        <v-col cols="12">
          <div class="font-weight-medium grey--text text--darken-2">
            Los campos con * son requeridos
          </div>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="registro.id_finca"
            :rules="[r.required]"
            :items="fincas"
            item-text="nombre"
            item-value="id"
            label="Finca *"
            outlined
            
          >
            <template slot="item" slot-scope="{ item }">
              <finca-select-item :item="item" />
            </template>
          </v-select>
        </v-col>
        <!-- <v-col cols="6">
          <modal-establecimiento />
          <v-select
            v-model="registro.id_establecimiento"
            clearable
            outlined
            :items="establecimientosPorId(registro.id_finca)"
            item-value="id"
            item-text="rua"
            label="RUA"
          />
        </v-col> -->
        <v-col cols="12">
          <div class="d-flex justify-end">
            <modal-parcela />
          </div>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="registro.id_parcela"
            clearable
            outlined
            :rules="[r.required]"
            :items="parcelasPorId(registro.id_finca)"
            item-value="id"
            item-text="nombre"
            label="Estanque, Jaula, Tina *"
          />
        </v-col>
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">
            Duración de esta Producción
          </div>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="registro.fecha"
            label="Fecha de Inicio *"
            range-type="production"
            :rules="[r.required]"
            outlined
            name="fecha"
            placeholder="aaaa-mm-dd"
            :date.sync="registro.fecha"
            @change="validarFecha"
          >
          </v-text-field>
          <p v-if="errorin" style="color: red">{{ errorin }}</p>
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="registro.fecha_fin"
            label="Fecha finalización"
            range-type="production"
            :date.sync="registro.fecha_fin"
            placeholder="aaaa-mm-dd"
            outlined
            @change="validarFechaf"
          >
          </v-text-field>
          <p v-if="errorinf" style="color: red">{{ errorinf }}</p>
        </v-col>
        <!--   <v-col cols="6">
          <v-text-field
            v-model.number="registro.ciclo"
            :rules="[r.required, r.int, r.min_num(1), r.max_num(9)]"
            label="Ciclo*"
            outlined
            @input="debounceBuscarRegistroExistente"
          />
        </v-col> -->
        <v-col cols="12">
          <div class="text-h6 font-weight-bold">Datos del Estanque</div>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model.number="registro.espejo_de_agua"
            :rules="[r.required, r.float]"
            label="Tamaño de estanque(espejo de agua) *"
            suffix="m2"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="registro.observacion"
            :rules="[r.max(1000)]"
            label="Tarea_Pendiente, Fecha, Observación"
            auto-grow
            outlined
            rows="1"
          ></v-textarea>
        </v-col>

        <v-row class="pa-2" align="center" justify="space-around">
          <v-col cols="5" class="d-flex justify-center">
            <v-btn
              block
              large
              :color="
                seccionActiva === 'produccion' ? 'green darken-3' : 'primary'
              "
              class="white--text font-weight-bold"
              elevation="4"
              @click="activarSeccion('produccion')"
            >
              <!-- <span style="font-size: 30px">🐟</span> -->
              1.Producción
            </v-btn>
          </v-col>

          <v-col cols="5" class="d-flex justify-center">
            <v-btn
              block
              large
              :color="seccionActiva === 'venta' ? 'green darken-3' : 'primary'"
              class="white--text font-weight-bold"
              elevation="4"
              @click="msghandleVentaClick"
            >
              <span style="font-size: 30px">💰</span>
              2. Ventas
            </v-btn>
          </v-col>
        </v-row>

        <!-- listado dinámico de producciones -->
        <v-row v-if="mostrarPlantacion">
          <v-row no-gutters>
            <v-col cols="12">
              <div class="text-h5 font-weight-bold mb-2">
                Producción de Especies
              </div>
              <div class="text-subtitle-1 mb-4">
                Complete la información para cada especie que tiene sembrada.
              </div>
            </v-col>
          </v-row>

          <v-row
            v-for="(produccion, index) in registro.producciones"
            :key="`producciones-${index}`"
            class="pa-3 mb-4"
            style="border: 1px solid #ddd; border-radius: 8px"
          >
            <v-col cols="12" md="6">
              <v-select
                v-model="produccion.id_especie_acuicola"
                :rules="[r.required]"
                :items="rubros_filtrados"
                item-text="descripcion"
                item-value="id"
                label="¿Qué especie sembró? *"
                outlined
                dense
            
              />
            </v-col>
               <!-- @input="debounceBuscarRegistroExistente" -->
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="produccion.ingreso_anual"
                :rules="[r.float]"
                label="¿Cuánto sembró (número aproximado)? *"
                outlined
                dense
              />
            </v-col>

            <v-col cols="12" md="8">
              <v-text-field
                v-model.number="produccion.produccion"
                :rules="[r.float]"
                label="¿Cuánto produjo?"
                outlined
                dense
              >
                <template v-slot:append>
                  <unit-picker @transform="produccion.produccion = $event" />
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12" md="4" class="d-flex align-center justify-end">
              <v-btn
                icon
                color="red"
                :disabled="!puedeRemoverProduccion"
                @click="removerProduccion(index)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-col cols="6">
            <v-btn
              block
              rounded
              class="primary--text"
              @click="agregarProduccion"
            >
              <v-icon left>mdi-plus</v-icon>
              Agrega Nueva especie en este Estanque
            </v-btn>
          </v-col>
        </v-row>
        <!-- Situación de desastre -->
        <!--         <v-col cols="12">
          <v-btn depressed block class="primary--text" @click="agregarDesastre">
            <v-icon left>mdi-plus</v-icon>
            Agregar situación de desastre
          </v-btn>
        </v-col>
        <situacion-de-desastre
          v-for="(desastre, index) in registro.desastres"
          :key="desastre.id_trxdano"
          :form="registro.desastres[index]"
          :modulo="'ACUICULTURA'"
          @eliminar="eliminarDesastre(index)"
        /> -->
        <!-- listado dinámico de destinos -->

        <div v-if="mostrarVenta" style="margin-top: 5px">
        
          <destino
            :destinos="registro.destinos"
            :producciones="registro.producciones"
            :listado-destinos="destino"
            :rubros="especie_acuicola"
            :tabla-produccion-id-rubro="tabla_produccion_id_rubro"
          />
        </div>

        <v-col cols="auto" class="ml-auto d-flex" style="margin-top: 5px">
          <save-btn
            class="btn-oval"
            :record-status="registro.estatus"
            :loading="loading"
            @click="antesDeGuardar"
          />
        </v-col>
      </v-row>
    </v-form>
    <registro-existente
      :title="'La producción ya existe'"
      :description="'Los datos colocados corresponden a una producción existente, desea cargar la información de esta producción?'"
      :loading="modal_registro_existe_loading"
      :modal="modal_registro_existe"
      @cerrarModal="cerrarModalRegistroExistente"
      @cargarDatos="cargarRegistroExistente"
    />
  </v-container>
</template>

<script>
import Form from '@/components/js/Form'
import { mapState, mapGetters } from 'vuex'
import { clona } from '../../utilidades'
import { danotrx } from '../../modelos'
import { produccion_acuicola, formulario_acuicultura } from '../../modelos'
import FincaSelectItem from '../../components/FincaSelectItem.vue'
import ModalParcela from '../../components/ModalParcela.vue'
import ModalEstablecimiento from '../../components/ModalEstablecimiento.vue'
import SituacionDeDesastre from '../../components/form/SituacionDeDesastre.vue'
export default {
  name: 'Acuicultura',
  components: {
    Destino: () => import('@/components/form/Destino.vue'),
    FincaSelectItem,
    ModalParcela,
    ModalEstablecimiento,
    SituacionDeDesastre,
  },
  extends: Form,
  data() {
    return {
      seccionActiva: 'produccion',
      mostrarPlantacion: true,
      mostrarVenta: false,
      errorin: '',
      errorinf: '',
      tabla_principal_id: 'id',
      tabla_produccion_id_rubro: 'id_especie_acuicola',
      ruta_registros: 'acuiculturas',
      ruta_registro: 'acuicultura',
      nombre_registros_en_state: 'acuiculturas',
      nombre_registro_en_state: 'acuicultura',
      dispatch_get_registro: 'getAcuicultura',
      dispatch_guardar_registro: 'guardarAcuicultura',
      registro: clona(formulario_acuicultura),
      registro_produccion: clona(produccion_acuicola),
    }
  },
  computed: {
    ...mapState('listados', ['especie_acuicola']),
    ...mapGetters('registros', [
      'establecimientosPorId',
      'parcelasPorId',
      'getMatchingRecords',
      'productor_actual',
    ]),
    ...mapGetters('listados', ['cultivo']),
    rubros_filtrados() {
      const selected = this.registro.producciones.map(
        (v) => v[this.tabla_produccion_id_rubro]
      )
      return this.especie_acuicola.map((v) => ({
        ...v,
        disabled: selected.includes(v.id),
      }))
    },
    alertSurfaceOverflow() {
      const id = this.registro.id
      const id_finca = this.registro.id_finca
      const year = (date) => new Date(date).getFullYear()
      const acuiculturas = this.getMatchingRecords({
        recordName: 'acuiculturas',
        matchValues: [
          { key: 'id_finca', value: id_finca },
          { key: 'ciclo', value: this.registro.ciclo },
        ],
        exceptIds: [id],
      })

      const fincas = this.getMatchingRecords({
        recordName: 'fincas',
        matchValues: [
          { key: 'id', value: id_finca },
          { key: 'id_productor', value: this.productor_actual },
        ],
      })

      const superficies_acuicolas = acuiculturas
        .filter((a) => year(a.fecha) === year(this.registro.fecha))
        .map((a) => a.espejo_de_agua)
        .reduce((a, b) => parseFloat(a) + parseFloat(b), 0)
      const overflow =
        superficies_acuicolas + parseFloat(this.registro.espejo_de_agua) >
        parseFloat(fincas?.[0]?.extension ?? 0)
      return (
        !overflow ||
        'La suma de las superficies de los espejos de agua para este año, ciclo y finca exceden la superficie de la finca'
      )
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Acuicultura')
    const id = this.obtenerIdDeRuta()
    if (id) {
      this.cargarRegistro(id)
      /* this.registro.fecha = this.formatearFechaParaFormulario(this.registro.fecha)
      if (this.registro.fecha_fin) {
        this.registro.fecha_fin = this.formatearFechaParaFormulario(this.registro.fecha_fin)
      } */
    } else {
      this.registro = clona(formulario_acuicultura)
      //Establece la fecha de inicio al cargar la página en fecha hoy
      //this.registro.fecha = this.fechaHoyDDMMYYYY()
    }

    this.registro.id_productor = this.productor_actual

    if (!this.registro.ciclo) {
      this.registro.ciclo = 1
    }
  },
  methods: {
    handleVentaClick() {
      this.$nextTick(() => {
        const tieneAcuicultura = this.registro.producciones?.some(
          (produccion) =>
            produccion.id_especie_acuicola && (produccion.ingreso_anual || produccion.produccion)
        )

        if (!tieneAcuicultura) {
          this.$store.commit('ui/setSnack', {
            text: 'Tu Producción esta vacia, llenala para que Aumente tú Producción y después llena tu venta 😉',
            color: 'blue',
          })
          return
        }

        this.activarSeccion('venta')
      })
    },
    msghandleVentaClick() {
      /* this.$nextTick(() => {
        const tieneAcuicultura = this.registro.producciones?.some(
          (produccion) =>
            produccion.id_especie_acuicola && (produccion.ingreso_anual || produccion.produccion)
        )
        if (!tieneAcuicultura) {
          // ✅ Mensaje informativo, no bloquea y se oculta solo
          this.$store.commit('ui/setSnack', {
            text: '🛒 Tu producción está vacía. Regístrala para aumentarla 😉',
            color: 'blue',
            timeout: 9000, // ⬅️ se oculta solo en 2 minutos (en ms)
            // optional:
            // multiline: true,
            // top: true,
          })
        } */
        this.activarSeccion('venta')
      //})
    },
    activarSeccion(seccion) {
      this.seccionActiva = seccion
      if (seccion === 'produccion') {
        this.pmostrarProduapi()
      } else {
        this.pmostrarVenta()
      }
    },
    //OJO OJO quizas falte: handleActividadChange(indice)
    pmostrarProduapi() {
      this.mostrarPlantacion = true
      this.mostrarVenta = false
    },
    pmostrarVenta() {
      this.mostrarPlantacion = false
      this.mostrarVenta = true
    },
    fechaHoyDDMMYYYY() {
      const hoy = new Date()
      const dia = String(hoy.getDate()).padStart(2, '0')
      const mes = String(hoy.getMonth() + 1).padStart(2, '0') // los meses van de 0 a 11
      const anio = hoy.getFullYear()
      return `${dia}-${mes}-${anio}`
    },
    validarFecha() {
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // aaaa-mm-dd
      const fecha = this.registro.fecha

      if (!regexFecha.test(fecha)) {
        this.errorin =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
        return
      }

      const [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.errorin = 'El mes debe estar en el rango de 1 a 12.'
        return
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.errorin = `El día no es válido para el mes ${mesInt} y año ${anioInt}.`
        return
      }

      this.errorin = '' // Fecha válida
    },
    validarFechaf() {
      const regexFecha = /^(\d{4})-(\d{2})-(\d{2})$/ // aaaa-mm-dd
      const fecha = this.registro.fecha_fin

      if (!regexFecha.test(fecha)) {
        this.errorinf =
          'Favor colocar año, mes y día separado con guiones así: aaaa-mm-dd'
        return
      }

      const [, anio, mes, dia] = fecha.match(regexFecha)
      const diaInt = parseInt(dia, 10)
      const mesInt = parseInt(mes, 10)
      const anioInt = parseInt(anio, 10)

      if (mesInt < 1 || mesInt > 12) {
        this.errorinf = 'El mes debe estar en el rango de 01 a 12.'
        return
      }

      const diasEnMes = new Date(anioInt, mesInt, 0).getDate()
      if (diaInt < 1 || diaInt > diasEnMes) {
        this.errorinf = 'El día no es válido para el mes especificado.'
        return
      }

      this.errorinf = '' // Fecha válida
    },
    //función que formatea la fecha para enviarla a la BD
    formatearFechaParaBD(fechaDDMMYYYY) {
      const regex = /^(\d{2})-(\d{2})-(\d{4})$/
      if (!regex.test(fechaDDMMYYYY)) return fechaDDMMYYYY
      const [, dia, mes, anio] = fechaDDMMYYYY.match(regex)
      return `${anio}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    //Función que formatea la fecha que que se trae de la BD para mostrarla en el front
    formatearFechaParaFormulario(fechaYYYYMMDD) {
      const regex = /^(\d{4})-(\d{2})-(\d{2})$/
      if (!regex.test(fechaYYYYMMDD)) return fechaYYYYMMDD
      const [, anio, mes, dia] = fechaYYYYMMDD.match(regex)
      return `${dia}-${mes}-${anio}`
    },

    limpiarRegistrosVacios() {
      this.registro.producciones = this.registro.producciones.filter((item) =>
        this.esEntradaValida(item)
      )
      /* this.registro.engorde = this.registro.engorde.filter((item) =>
        this.esEngordeValido(item)
      ) */
      this.registro.destinos = (this.registro.destinos || []).filter((item) =>
        this.esDestinoValido(item)
      )
      this.$nextTick(() => {})
    },

    //esta funcion es para que las fechas se envien en el formato aaaa-mm-dd a la BD
    //antes de guardarycontinuar para no modificar la funcion original de guardar que esta en Form.js
    async antesDeGuardar() {
      this.limpiarRegistrosVacios()

      const tieneDestino =
        this.registro.destinos && this.registro.destinos.length > 0
      const tieneProduccionValida = this.registro.producciones?.some(
        (produccion) => produccion.id_especie_acuicola && (produccion.ingreso_anual || produccion.produccion)
      )

      if (tieneDestino && !tieneProduccionValida) {
        this.$store.commit('ui/setSnack', {
          text: 'Recuerde registrar al menos una producción antes de guardar una venta',
          color: 'error',
        })
        return
      }

      //Esperar a que termine la limpieza
      await this.$nextTick()
      /* this.registro.fecha = this.formatearFechaParaBD(this.registro.fecha)
      if (this.registro.fecha_fin){
        this.registro.fecha_fin = this.formatearFechaParaBD(this.registro.fecha_fin)
      } */
      //aqui llama entonces a la funcion guardar con la fecha formateada y lista
      this.guardarYContinuar()
    },

    esEntradaValida(item) {
      return item.id_especie_acuicola
    },

    esDestinoValido(destino) {
      return destino.rubro
    },

    async obtenerUnRegistroONada() {
      try {
        const id_productor = this.registro.id_productor
        const ciclo = this.registro.ciclo
        const fecha = this.registro.fecha
        const id_finca = this.registro.id_finca
        const id_parcela = this.registro.id_parcela
        //id_rubros es el arreglo de rubros con datos
        const id_rubros = !this.obtenerIdDeRuta()
          ? this.registro.producciones
              .filter((prod) => !!prod.id_especie_acuicola)
              .map((prod) => prod.id_especie_acuicola)
          : []
        //  rubros:variabale, se vuelve true o false
        const rubros =
          (!this.obtenerIdDeRuta() && id_rubros.length > 0) ||
          this.obtenerIdDeRuta()

        // id_rubros es un arreglo de los rubros son varios que tiene el registro
        if (fecha && id_finca && rubros) {
          const { status, data } = await this.$store.dispatch(
            'registros/listarAcuiculturasx',
            {
              id_productor,
              ciclo,
              fecha,
              id_finca,
              id_parcela,
              id_rubros,
            }
          )
          if (status === 'ok' && data.length > 0) return data[0]
        }
        return {}
      } catch (e) {
        return {}
      }
    },
    Cancelar() {
      this.$router.push('/ru/acuiculturas')
    },
    agregarDesastre() {
      this.registro.desastres?.push({ ...danotrx })
    },
    eliminarDesastre(index) {
      this.registro.desastres?.splice(index, 1)
    },
  },
}
</script>

<style>
.btn-oval {
  border-radius: 50px; /* Hace que el botón sea más ovalado */
}
.btn-final {
  display: flex;
}
.cancel {
  background-color: red !important;
  color: white !important;
}
</style>
